import React, { Component, useState, useRef, Fragment } from 'react'
import { sagaModal } from 'redux-saga-modal'
import { Form, Modal, Button, message, Spin, Input, InputNumber } from 'antd'
import * as apis from '@/apis'
import styles from './recharge.module.scss'
import QRCode from 'qrcode.react'

const formItemLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 15 },
}

@Form.create()
class RechargeForm extends Component {
  state = {
    loading: false,
    transaction: null
  }

  handleSubmit = e => {
    const { submit } = this.props
    e.preventDefault()

    this.props.form.validateFields((err, values) => {
      if (err) {
        Object.entries(err).forEach(([_, { errors }]) => {
          errors.forEach(({ message: msg }) => {
            message.error(msg)
          })
        })

        return console.error(err)
      }

      // submit(values)
      console.log('values:', values)
      apis.recharge({ amount: values.amount })
        .then(res => {
          this.setState({
            transaction: res,
            loading: false
          })
        })
        .catch(err => {
          message.error(err.message || 'API异常，请稍后再试')
          this.setState({
            loading: false
          })
        })
    });
  }

  renderForm() {
    const { getFieldDecorator, validateFields, getFieldValue } = this.props.form

    return (
      <Form onSubmit={this.handleSubmit}>
        <Form.Item
          {...formItemLayout}
          label="金额"
          required>
          {getFieldDecorator('amount', {
            rules: [
              {
                required: true,
                message: '请输入金额',
              },
            ],
          })(
            <InputNumber style={{width: 120}} placeholder="金额" />
          )}
          <span style={{marginLeft: 5}}>元</span>
        </Form.Item>
        <div className={styles.footer}>
          <Button type="primary" htmlType="submit">充值</Button>
        </div>
      </Form>
    )
  }

  renderQrCode() {
    const codeUrl = `https://api.xiaobingsubang.com/transactions/${this.state.transaction._id}/precreate`
    return (
      <div>
        <center>
          <QRCode value={codeUrl} />
          <div style={{marginTop: 10, color: '#ccc'}}>
            <span>充值{this.state.transaction.amount}元</span>
            <p>请通过微信/支付宝扫描二维码进行支付，支付成功后再关闭此窗口。</p>
          </div>
        </center>
        <div className={styles.footer}>
          <Button type="primary" onClick={() => { window.location.reload() }}>完成</Button>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div>
        <Spin spinning={this.state.loading}>
          {
            this.state.transaction ? this.renderQrCode(): this.renderForm()
          }
        </Spin>
      </div>
    )
  }
}

const RechargeDialog = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={ownProps.title}
    destroyOnClose
    footer={null}
    width={500}
    centered
    visible={isOpen}
    maskClosable={false}
    onCancel={hide}>
    <RechargeForm submit={submit} {...ownProps} />
  </Modal>
)

export default sagaModal({
  name: 'RECHARGE_DIALOG',
 })(RechargeDialog)
